export default ({ key, allUrl, initial }) => ({
  pending: Array.isArray(initial) ? initial.slice() : [],
  _initialKey: '',

  init() {
    this._initialKey = this._key(this.pending)
  },

  isPending(slug) {
    return this.pending.includes(slug)
  },

  get allPending() {
    return this.pending.length === 0
  },

  get hasChanges() {
    return this._key(this.pending) !== this._initialKey
  },

  toggle(slug) {
    const i = this.pending.indexOf(slug)
    if (i >= 0) {
      this.pending.splice(i, 1)
    } else {
      this.pending.push(slug)
    }
  },

  selectAll() {
    this.pending = []
  },

  apply() {
    if (!this.hasChanges) return

    const url = new URL(allUrl, window.location.origin)
    if (this.pending.length) {
      url.searchParams.set(key, this.pending.join(','))
    } else {
      url.searchParams.delete(key)
    }
    window.location.href = url.toString()
  },

  _key(list) {
    return list.slice().sort().join(',')
  },
})
